import { render, staticRenderFns } from "./DialogConsultaPedido.vue?vue&type=template&id=2128c18c&scoped=true&"
import script from "./DialogConsultaPedido.vue?vue&type=script&lang=js&"
export * from "./DialogConsultaPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2128c18c",
  null
  
)

export default component.exports